export const DotIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <g filter="url(#b)">
        <circle cx="12" cy="12" r="3" fill="currentColor"></circle>
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
      <filter
        id="b"
        width="30"
        height="30"
        x="-3"
        y="-3"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset></feOffset>
        <feGaussianBlur stdDeviation="6"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0.380791 0 0 0 0 0.896012 0 0 0 0 0.807689 0 0 0 1 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5867_19855"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5867_19855"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);
